import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        adaptiveParagraph: {
          module: () => import('./adaptive-paragraph-lazy.module').then((m) => m.AdaptiveParagraphLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.RosaCMSAdaptiveParagraphComponent],
        },
      },
    }),
  ],
})
export class AdaptiveParagraphModule {}
